import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { CommonService, PollsService } from '../../services';
import { FormControl, FormGroup } from '@angular/forms';
import { SystemHelpers } from '../../helpers';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-targets',
  templateUrl: './app-targets.component.html',
  styleUrls: ['./app-targets.component.scss'],
  providers: [PollsService]
})
export class AppTargetsComponent implements OnInit {

  public countries: any[];
  public cities: Object[];
  public universities: Object[];
  public faculties: any = [];
  public active_targets: String[];
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteTarget: EventEmitter<any> = new EventEmitter<any>();
  @Input() targets: any[];
  @Input() campaign: number; // campaigns_id
  @Input() disabled: boolean;
  @Input() showOnlyFaculties = false;
  public targetForm = new FormGroup({
    countries_id: new FormControl(),
    cities_id: new FormControl(),
    universities_id: new FormControl(),
    faculty_tag: new FormControl()
  });

  public cityList: {[key: string]: any} = {};
  public universityList: {[key: string]: any} = {};

  constructor(private commonService: CommonService) {
  }

  ngOnInit() {
    this.active_targets = [];

    this.commonService.getFaculties()
      .subscribe(faculties => {
        this.faculties = [];
        faculties.map((value) => {
          this.faculties.push({ label: SystemHelpers.facultyTrans(value['tag']), value: String(value['tag']) });
        });
      });

    this.commonService.getCountries()
      .subscribe(countries => {
        countries = countries['countries'];
        this.countries = [];
        countries.map((value) => {
          this.countries.push({ label: value['name'], value: String(value['id']) });
        });

        if (this.targets) {
          this.targets.forEach((t => {
            const cityObs: Observable<any> = (t.countries_id) ? this.commonService.getCities(Number(t.countries_id)) : of(true);

            cityObs.subscribe(cities => {
              if (cities !== true) {
                this.cityList[t.countries_id] = cities.cities;
              }
              let uniObs: Observable<any>;
              if (t.cities_id) {
                uniObs = this.commonService.getUniversities(Number(t.cities_id));
              } else {
                uniObs = of(true);
              }
              uniObs.subscribe(result => {
                if (result !== true) {
                  this.universityList[t.cities_id] = result.universities;
                }
                this.retrieveActiveTargets(t);
              });
            });
          }));
        }


      });
  }

  onSelect(type, event) {

    // event undefined === user is changing value of the ng-select
    // event not undefined === user is clearing the ng-select
    if (typeof event !== 'undefined') {
      switch (type) {
        case 'country':
          this.targetForm.controls['cities_id'].reset();
          delete this.universities;
          this.targetForm.controls['universities_id'].reset();
          this.commonService.getCities(event.value)
            .subscribe(cities => {
              cities = cities['cities'];
              this.cities = [];
              cities.map((value) => {
                this.cities.push({ label: value['name'], value: String(value['id']) });
              });
            });
          break;
        case 'city':
          this.targetForm.controls['universities_id'].reset();
          this.commonService.getUniversities(event.value)
            .subscribe(universities => {
              universities = universities['universities'];
              this.universities = [];
              universities.map((value) => {
                this.universities.push({ label: value['name'], value: String(value['id']) });
              });
            });
          break;
      }
    } else {
      // clicked clear
      this.onClear(type);
    }
  }

  onClear(type) {
    switch (type) {
      case 'country':
        delete this.cities;
        this.targetForm.controls['cities_id'].reset();
        break;
      case 'city':
        delete this.universities;
        this.targetForm.controls['universities_id'].reset();
    }
  }

  isValid() {
    return this.targetForm.controls['countries_id'].value ||
      this.targetForm.controls['cities_id'].value ||
      this.targetForm.controls['faculty_tag'].value ||
      this.targetForm.controls['universities_id'].value;
  }

  createActiveTargetsLabels(form) {
    let target = '';
      if (form.controls['faculty_tag'].value) {
        target += SystemHelpers.facultyTrans(form.controls['faculty_tag'].value.value);
      }
      if (form.controls['countries_id'].value && !form.controls['cities_id'].value && !form.controls['universities_id'].value) {
        target += target.length > 0 ? ' - ' + this.createLabel('country', this.countries, form.controls['countries_id'].value.value) :
          this.createLabel('country', this.countries, form.controls['countries_id'].value.value);
      }
      if (form.controls['cities_id'].value && !form.controls['universities_id'].value) {
        target += target.length > 0 ?
          ' - ' + this.createLabel('city', this.cities, form.controls['cities_id'].value.value) :
          this.createLabel('city', this.cities, form.controls['cities_id'].value.value);
      }
      if (form.controls['universities_id'].value) {
        target += target.length > 0 ?
          ' - ' + this.createLabel('university', this.universities, form.controls['universities_id'].value.value) :
          this.createLabel('university', this.universities, form.controls['universities_id'].value.value);
      }
    this.active_targets.push(target);

  }

  retrieveActiveTargets(_targetObject) {
    let target = '';
      if (_targetObject.faculty_tag) {
        target += SystemHelpers.facultyTrans(_targetObject.faculty_tag);
      }
      if (_targetObject.countries_id && !_targetObject.cities_id && !_targetObject.universities_id) {
        if (_targetObject.Country && _targetObject.Country.name) {
          target += target.length > 0 ? ' - ' + _targetObject.Country.name : _targetObject.Country.name;
        } else {
          const countryName = this.countries.filter(country => Number(country.value) === _targetObject.countries_id)[0].label;
          target += target.length > 0 ? ' - ' + countryName : countryName;
        }
      }
      if (_targetObject.cities_id && !_targetObject.universities_id) {
        if (_targetObject.City && _targetObject.City.name) {
          target += target.length > 0 ? ' - ' + _targetObject.City.name : _targetObject.City.name;
        } else {
          const cityName = this.cityList[_targetObject.countries_id].filter(city => city.id === _targetObject.cities_id)[0].name;
          target += target.length > 0 ? ' - ' + cityName : cityName;
        }
      }
      if (_targetObject.universities_id) {
        if (_targetObject.University && _targetObject.University.name) {
          target += target.length > 0 ? ' - ' + _targetObject.University.name : _targetObject.University.name;
        } else {
          const universityName = this.universityList[_targetObject.cities_id].filter(u => u.id === _targetObject.universities_id)[0].name;
          target += target.length > 0 ? ' - ' + universityName : universityName;
        }
      }
      this.active_targets.push(target);
  }

  addTarget() {
    this.createActiveTargetsLabels(this.targetForm);

    const formValue = this.targetForm.value;
    for (const key in formValue) {
      if (formValue[key]) {
        console.log(key, formValue[key]);
        if (formValue[key]) {
          if (key === 'cities_id' || key === 'universities_id') {
            formValue[key] = parseInt(formValue[key].value, 10);
            formValue['countries_id'] = 1;
          } else {
            formValue[key] = formValue[key].value;
          }
        } else {
          delete formValue[key];
        }
      }
    }
    if (!this.targets) {
      this.targets = [];
    }

    this.notify.emit(formValue);

    delete this.cities;
    delete this.universities;
    this.targetForm.controls['countries_id'].reset();
    this.targetForm.controls['cities_id'].reset();
    this.targetForm.controls['universities_id'].reset();
    this.targetForm.controls['faculty_tag'].reset();
  }

  createLabel(type, list, value) {
    console.log(type, list, value);

    let label = '';
    for (let i = 0; i < list.length; i++) {
      if (list[i].value.toString() === value.toString()) {
        label += list[i].label;
      }
    }
    return label;
  }

  removeTarget(target, index) {
    this.active_targets.splice(index, 1);
    this.deleteTarget.emit(index);
    this.targets.splice(index, 1);
  }

}
